module.exports = __webpack_public_path__ + "static/media/upload-finish-page.e5285cbc.svg";